import * as ajaxForm from '../../ajax-form';

export const initInScope = ajaxForm.createInitInScope({}, {
    base: '.js-ejb-ajax-form',
    result: '.js-ejb-ajax-form__result',
    loading: '.js-ejb-ajax-form__loading',
    notifications: '.js-ejb-ajax-form__notifications',
    form: '.js-ejb-ajax-form__form',
    link: '.js-ejb-ajax-form__link'
});